import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { trackPageView } from "../../utils/analytics";

/**
 * Sends a GA4 page_view on every React Router navigation *after* the first one.
 *
 * The initial page load is already counted by the base `gtag('config', …)` call
 * in public/index.html, so we deliberately skip the first location to avoid
 * double-counting the entry page. Every in-app navigation after that fires
 * exactly one page_view.
 *
 * Renders nothing — it exists only to run this effect from inside <Router>,
 * where useLocation() has access to the current route. Mount it once, as a
 * child of <Router> (see App.tsx).
 */
export function RouteAnalytics(): null {
  const { pathname, search } = useLocation();
  const isInitialLoad = useRef(true);

  useEffect(() => {
    // Skip the entry page: public/index.html's gtag('config') already logged it.
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      return;
    }

    trackPageView(pathname + search);
  }, [pathname, search]);

  return null;
}
